// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"74":"About","384":"workstudyplus-parent","784":"Logins"}[chunkId] || chunkId) + "." + {"74":"e88138ad","384":"2cc4d7cd","552":"909d1e71","727":"86b027a8","761":"be70a6a5","784":"ff839103","889":"2335eee9","890":"e78aad4e"}[chunkId] + ".js";
};